import { PageMeta } from "../components/PageMeta";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { ProductCard } from "../components/ProductCard";
import { useEnquiry } from "../components/EnquiryModal";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES, PRODUCTS } from "../data/content";
import { ArrowUpRight } from "lucide-react";

export default function Products() {
  const { open } = useEnquiry();
  const { t } = useLanguage();

  return (
    <main>
      <PageMeta
        title="Our Products | Spice, Pulse, Cereals, Nuts & Dry Fruits Importer Dubai"
        description="Al Nama Importer trades cereals, spices, pulses, agro commodities, nuts and dry fruits, sourced from international markets for wholesale and commercial buyers."
        titleAr="منتجاتنا | مستورد توابل وبقوليات وحبوب ومكسرات وفواكه مجففة في دبي"
        descriptionAr="تتاجر النعم للاستيراد في الحبوب والتوابل والبقوليات والسلع الزراعية والمكسرات والفواكه المجففة الموردة من الأسواق الدولية لتجار الجملة والمشترين التجاريين."
      />
      <PageHero
        image={IMAGES.spiceBaskets}
        overline={t("productsPage.heroOver")}
        titleLines={[t("productsPage.heroL1"), t("productsPage.heroL2")]}
        text={t("productsPage.heroText")}
      />

      <section className="bg-[#09121F] py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {PRODUCTS.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.1}>
                <ProductCard product={p} index={i} />
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <div className="mt-16 flex flex-col items-center justify-between gap-6 rounded-lg border border-amber-500/20 bg-[#0B1D16]/70 p-8 sm:flex-row sm:p-10">
              <p className="max-w-xl text-sm font-light leading-relaxed text-slate-300/85 sm:text-base">
                {t("productsPage.note")}
              </p>
              <button
                data-testid="products-page-enquiry-btn"
                onClick={() => open({ type: "Product Enquiry" })}
                className="group inline-flex shrink-0 items-center gap-3 rounded-full bg-gradient-to-br from-[#DFB756] to-[#C49A2D] px-8 py-4 font-display text-sm font-semibold uppercase tracking-[0.15em] text-[#0B1D16] transition-transform duration-300 hover:scale-105"
              >
                {t("productsPage.enquire")}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
